class WelcomeOfferPanel extends HTMLElement {
  constructor() {
    super();
    // bind handlers once
    this.closeOverlayHandler = this.close.bind(this);
    this.closeButtonHandler = this.close.bind(this);
    this.escapeKeyHandler = this.handleEscape.bind(this);
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    // overlay click to close
    this.overlay = this.querySelector('.panel-overlay');
    this.overlay?.addEventListener('click', this.closeOverlayHandler);

    // close button click
    this.closeButton = this.querySelector('.drawer_close');
    this.closeButton?.addEventListener('click', this.closeButtonHandler);
  }

  removeEventListeners() {
    this.overlay?.removeEventListener('click', this.closeOverlayHandler);
    this.closeButton?.removeEventListener('click', this.closeButtonHandler);
    document.removeEventListener('keydown', this.escapeKeyHandler, true);
  }

  handleEscape(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.close();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  addClubToCart() {
    window.__abc.addClubMembershipToCart();
    this.close();
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    // trap focus inside the panel
    const container = this.querySelector('.drawer__inner');
    const fallbackFocus = this.querySelector('.drawer_close');
    if (typeof trapFocus === 'function' && container) {
      trapFocus(container, fallbackFocus);
    }

    // **KEY**: listen for Escape in capture phase
    document.addEventListener('keydown', this.escapeKeyHandler);
  }

  close() {
    this.classList.remove('active');
    document.removeEventListener('keydown', this.escapeKeyHandler);

    if (typeof removeTrapFocus === 'function' && this.activeElement) {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');

    // return focus to the triggering element
    if (this.activeElement) {
      this.activeElement.focus();
    }
  }

  setActiveElement(el) {
    this.activeElement = el;
  }
}

customElements.define('welcome-offer-panel', WelcomeOfferPanel);

document.addEventListener('DOMContentLoaded', () => {
  /*
  const panel = document.querySelector('welcome-offer-panel');
  if (panel) {
    // Small delay to ensure everything is ready
    setTimeout(() => {
      panel.open();
    }, 100);
  }*/

  // Also handle manual triggers
  document.querySelectorAll('.launch_welcome_offer').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const panel = document.querySelector('welcome-offer-panel');
      if (panel) panel.open(link);
    });
  });
});
